export type RBACType =
  | 'device'
  | 'credentials'
  | 'rbac.role'
  | 'connectivity_costs'
  | 'credential_vault'
  | 'dashboards'
  | 'saved_views'
  | 'synthetics.agent'
  | 'synthetics.test'
  | 'rbac.role.users'
  | 'rbac.permission'
  | 'tenant'
  | 'package'
  | 'alerting.policies'
  | 'alerting.notifications'
  | 'alerting.silences'
  | 'alerting.suppressions'
  | 'alerting.autoacks'
  | 'protect.mitigations'
  | 'protect.announcements';

export type RBACAction = 'create' | 'read' | 'update' | 'delete';

export type RBACString =
  | `${RBACType}::${RBACAction}`
  | 'rbac.role.user::assign_to_role'
  | 'rbac.role.user::remove_from_role'
  | 'alerting.alerts::read'
  | 'alerting.alerts::clear'
  | 'alerting.alerts::ack'
  | 'alerting.alerts::debug'
  | 'alerting.policies::debug'
  | 'protect.mitigations::start'
  | 'protect.mitigations::stop'
  | 'protect.mitigations::manual'
  | 'protect.announcements::read'
  | 'protect.announcements::withdraw';

/**
 * TODO WARNING: Unfortunately you can't add any more roles to this collection as the backend does not support this!
 * TODO You will first need to verify that fetchPermittedLabelItems has been updated to allow for multi-permission fetches.
 * TODO then remove these TODOs so nobody else worries about it :)
 */
export const NECESSARY_RBAC_ROLES_FOR_SUBSCRIPTIONS: RBACString[] = ['device::read'];
